import React from 'react';
import { Typography } from 'antd';

import { useTransferModalStore } from '../../model/store';

import LeftGroup from '../LeftGroup/LeftGroup';
import MoveButton from '../MoveButton/MoveButton';
import RightGroup from '../RightGroup/RightGroup';

import styles from './Transfer.module.scss';

type TransferProps = {
  disableUserSelection: boolean;
};

const Transfer: React.FC<TransferProps> = ({ disableUserSelection }) => {
  const {
    groupName,
    usersMovedToGroup,
    usersMovedFromGroup,
    moveUsers,
    selectedFromAll,
    selectedFromGroup,
    selectFromGroup,
    selectFromAll,
  } = useTransferModalStore();

  const handleTransferToGroup = (): void => {
    const newSelectedToMoveToGroup = selectedFromAll.filter(
      (user) => !usersMovedFromGroup.find((u) => u.id === user.id),
    );
    if (newSelectedToMoveToGroup.length) {
      moveUsers([...usersMovedToGroup, ...newSelectedToMoveToGroup], 'toGroup');
    }

    const selectedToMoveBack = selectedFromAll.filter((user) => usersMovedFromGroup.find((u) => u.id === user.id));
    if (selectedToMoveBack.length) {
      moveUsers(
        usersMovedFromGroup.filter((user) => !selectedToMoveBack.find((u) => u.id === user.id)),
        'fromGroup',
      );
    }

    selectFromAll([]);
  };

  const handleTransferFromGroup = (): void => {
    const newSelectedToMoveFromGroup = selectedFromGroup.filter(
      (user) => !usersMovedToGroup.find((u) => u.id === user.id),
    );
    if (newSelectedToMoveFromGroup.length) {
      moveUsers([...usersMovedFromGroup, ...newSelectedToMoveFromGroup], 'fromGroup');
    }

    const selectedToMoveBack = selectedFromGroup.filter((user) => usersMovedToGroup.find((u) => u.id === user.id));
    if (selectedToMoveBack.length) {
      moveUsers(
        usersMovedToGroup.filter((user) => !selectedToMoveBack.find((u) => u.id === user.id)),
        'toGroup',
      );
    }

    selectFromGroup([]);
  };

  return (
    <article className={styles.modalContent}>
      <header>
        <Typography.Title level={2}>{groupName}</Typography.Title>
      </header>
      <div className={styles.container}>
        <LeftGroup
          disableUserSelection={disableUserSelection}
          selectedUsers={selectedFromGroup}
          onChangeSelectedUsers={selectFromGroup}
        />
        <div className={styles.moveButtons}>
          <MoveButton onClick={handleTransferFromGroup} isActive={selectedFromGroup.length > 0} direction="right" />
          <MoveButton onClick={handleTransferToGroup} isActive={selectedFromAll.length > 0} direction="left" />
        </div>
        <RightGroup
          disableUserSelection={disableUserSelection}
          selectedUsers={selectedFromAll}
          onChangeSelectedUsers={selectFromAll}
        />
      </div>
    </article>
  );
};

export default Transfer;
